import { formatMoney, type PaymentMethod, type VisitDto } from '@kominiarz/shared';
import { Banknote } from 'lucide-react';
import { useState } from 'react';
import { errorMessage } from '../../lib/api';
import { todayLocal } from '../../lib/calendarDates';
import { useCloseVisit } from '../../lib/visitsApi';
import { Button } from '../Button';
import { Dialog } from '../Dialog';
import { OfflineNotice } from '../OfflineNotice';
import { useOnline } from '../../lib/appStatus';
import { useToast } from '../Toast';
import { PaymentFields } from './PaymentFields';

/** "Oznacz jako opłacone": the payment method and date, nothing else. */
export function PaymentDialog({ visit, onClose }: { visit: VisitDto; onClose: () => void }) {
  const [method, setMethod] = useState<PaymentMethod | null>(visit.paymentMethod);
  const [paidAt, setPaidAt] = useState(todayLocal());
  const [error, setError] = useState<string>();
  const close = useCloseVisit();
  const online = useOnline();
  const toast = useToast();

  async function save() {
    if (!method) {
      setError('Wybierz formę płatności.');
      return;
    }
    try {
      await close.mutateAsync({ id: visit.id, body: { paymentStatus: 'paid', paymentMethod: method, paidAt } });
      toast.success('Oznaczono jako opłacone');
      onClose();
    } catch (err) {
      setError(errorMessage(err));
    }
  }

  return (
    <Dialog
      open
      title={visit.amountGrosze ? `Opłacone: ${formatMoney(visit.amountGrosze)}` : 'Oznacz jako opłacone'}
      onClose={onClose}
      actions={
        <>
          <Button variant="primary" size="lg" icon={<Banknote aria-hidden="true" />} onClick={save} disabled={close.isPending || !online}>
            Zapisz płatność
          </Button>
          <Button variant="secondary" size="lg" onClick={onClose}>
            Anuluj
          </Button>
        </>
      }
    >
      <OfflineNotice />
      <PaymentFields
        method={method}
        paidAt={paidAt}
        onMethod={(m) => {
          setMethod(m);
          setError(undefined);
        }}
        onPaidAt={setPaidAt}
        error={error}
      />
    </Dialog>
  );
}
